import React from 'react';
import LegalLayout, { LegalSection } from '../components/layout/LegalLayout';
const BUSINESS_NAME = 'Carros de la Cruz';
const BUSINESS_EMAIL = 'info@faranduladelacruz.com';
const BUSINESS_PHONE = '(857) 271-5381';
const BUSINESS_ADDRESS = '21400 NW 2nd Ave, Miami Gardens, FL 33169';
const TermsOfService = () => {
  return <LegalLayout title="Términos de Servicio / Terms of Service" updated="Última actualización / Last updated: 16 de agosto, 2026" data-id="element-514" data-mp="38stlfjsym3pe">
      <LegalSection heading="1. Aceptación / Acceptance" data-id="element-515" data-mp="4dsniote49ha">
        <p data-id="element-516" data-mp="4dalfbk1r11g">
          Al usar faranduladelacruz.com aceptas estos Términos de Servicio. Si
          no estás de acuerdo, no uses el sitio.
        </p>
        <p data-id="element-517" data-mp="3rqmkgb0gpthi">
          By using faranduladelacruz.com you agree to these Terms of Service. If
          you do not agree, please do not use the site.
        </p>
      </LegalSection>

      <LegalSection heading="2. Qué ofrecemos / What we offer" data-id="element-518" data-mp="o1t2f5uwf852">
        <p data-id="element-519" data-mp="o3ciowgk1j6u">
          {BUSINESS_NAME} es un servicio de asistencia para la compra y
          financiamiento de vehículos operado por Pedro de la Cruz, Fleet
          Manager. Este sitio permite enviar una solicitud para ser contactado.
          Enviar el formulario no constituye una aprobación de crédito ni una
          oferta vinculante de venta.
        </p>
        <p data-id="element-520" data-mp="13rnbkpzaeyg9">
          {BUSINESS_NAME} is a vehicle purchase and financing assistance service
          operated by Pedro de la Cruz, Fleet Manager. This site lets you submit
          a request to be contacted. Submitting the form does not constitute a
          credit approval or a binding offer of sale.
        </p>
      </LegalSection>

      <LegalSection heading="3. Sin garantía de aprobación / No approval guarantee" data-id="element-521" data-mp="1rgopgsqw31sx">
        <p data-id="element-522" data-mp="1miwo784cu3c2">
          Toda mención de "aprobación", "programas ITIN" o "sin crédito" se
          refiere a programas disponibles a través de prestamistas terceros. La
          aprobación final, tasas, plazos y pagos mensuales dependen
          exclusivamente del prestamista y de tu perfil financiero. No
          garantizamos ningún resultado.
        </p>
        <p data-id="element-523" data-mp="1x56kd1cq7s91">
          Any mention of "approval", "ITIN programs", or "no credit" refers to
          programs available through third-party lenders. Final approval, rates,
          terms, and monthly payments are determined solely by the lender and
          your financial profile. We guarantee no specific outcome.
        </p>
      </LegalSection>

      <LegalSection heading="4. Uso del formulario / Use of the form" data-id="element-524" data-mp="2b57lmhwwl1p1">
        <p data-id="element-525" data-mp="2g3ivutr41e7s">
          Debes tener al menos 18 años y proporcionar información veraz y
          propia. No envíes datos de terceros sin su autorización. Nos
          reservamos el derecho de rechazar o descartar solicitudes
          fraudulentas, duplicadas o incompletas.
        </p>
        <p data-id="element-526" data-mp="2twqn2kba47oy">
          You must be at least 18 years old and provide accurate information
          that belongs to you. Do not submit third-party data without their
          authorization. We reserve the right to reject or discard fraudulent,
          duplicate, or incomplete requests.
        </p>
      </LegalSection>

      <LegalSection heading="5. Comunicaciones / Communications" data-id="element-527" data-mp="i729l3gxrx8w">
        <p data-id="element-528" data-mp="e6igcazhhds1">
          Al enviar el formulario autorizas que te contactemos por teléfono,
          SMS, WhatsApp o correo electrónico. El consentimiento para recibir
          mensajes de marketing no es condición de compra. Responde{' '}
          <strong data-id="element-529" data-mp="15xoeilvn91eo">STOP</strong> en cualquier momento para cancelar los SMS, o{' '}
          <strong data-id="element-530" data-mp="11xw6qbe2qzad">HELP</strong> para ayuda. Pueden aplicar tarifas de mensajes y
          datos.
        </p>
        <p data-id="element-531" data-mp="x4bgj5iq39lq">
          By submitting the form you authorize us to contact you by phone, SMS,
          WhatsApp, or email. Consent to receive marketing messages is not a
          condition of purchase. Reply <strong data-id="element-532" data-mp="1pnqh8max8brg">STOP</strong> at any time to
          cancel SMS, or <strong data-id="element-533" data-mp="1kuxe22v3pbhh">HELP</strong> for help. Message and data rates
          may apply.
        </p>
      </LegalSection>

      <LegalSection heading="6. Propiedad intelectual / Intellectual property" data-id="element-534" data-mp="14ewmfy566bpx">
        <p data-id="element-535" data-mp="19fkbie9u8ihi">
          Todo el contenido de este sitio (textos, imágenes, video, marca) es
          propiedad de {BUSINESS_NAME} o se usa con autorización. No puede
          copiarse ni reutilizarse sin permiso escrito.
        </p>
        <p data-id="element-536" data-mp="10f5p1bl50xcf">
          All content on this site (text, images, video, branding) is owned by{' '}
          {BUSINESS_NAME} or used with permission. It may not be copied or
          reused without written permission.
        </p>
      </LegalSection>

      <LegalSection heading="7. Limitación de responsabilidad / Limitation of liability" data-id="element-537" data-mp="1ee5c4et0546h">
        <p data-id="element-538" data-mp="1ecayzmnz2gcy">
          El sitio se proporciona "tal cual". En la medida permitida por la ley,
          no somos responsables por daños indirectos, incidentales o
          consecuentes derivados del uso del sitio o de decisiones de
          financiamiento tomadas por prestamistas terceros.
        </p>
        <p data-id="element-539" data-mp="2l8bhy03x2ex7">
          The site is provided "as is". To the extent permitted by law, we are
          not liable for indirect, incidental, or consequential damages arising
          from use of the site or from financing decisions made by third-party
          lenders.
        </p>
      </LegalSection>

      <LegalSection heading="8. Cambios / Changes" data-id="element-540" data-mp="2pz1m5a0lwbqb">
        <p data-id="element-541" data-mp="2pzl7l0pgti93">
          Podemos actualizar estos términos en cualquier momento. La fecha de
          "última actualización" indica la versión vigente. / We may update these
          terms at any time. The "last updated" date indicates the current
          version.
        </p>
      </LegalSection>

      <LegalSection heading="9. Contacto / Contact" data-id="element-542" data-mp="2c97z8x8nw1j8">
        <p data-id="element-543" data-mp="278tov8jl8fi1">
          {BUSINESS_NAME}
          <br data-id="element-544" data-mp="277sg5aq1o53h" />
          {BUSINESS_ADDRESS}
          <br data-id="element-545" data-mp="3nmtnmg6p5z3p" />
          {BUSINESS_PHONE}
          <br data-id="element-546" data-mp="3nlqzgg0rearh" />
          <a href={`mailto:${BUSINESS_EMAIL}`} className="text-primary underline" data-id="element-547" data-mp="3nl8qqjwwu42o">
            {BUSINESS_EMAIL}
          </a>
        </p>
      </LegalSection>
    </LegalLayout>;
};
export default TermsOfService;